/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { Header, QuickLinks } from '../../components';

class Destinations extends React.Component {
  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Header title={t('destinations.label.title')} />
        <Divider />
        <QuickLinks />
      </React.Fragment>
    );
  }
}

Destinations.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Destinations);
